export const fileDocSvg = (
  // <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M3 3a2 2 0 0 1 2-2h9.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z"
  //     fill="#336DF4"
  //   />
  //   <path
  //     opacity="0.7"
  //     d="M15 1.483a.2.2 0 0 1 .341-.142L20.66 6.66a.2.2 0 0 1-.142.341H17a2 2 0 0 1-2-2V1.483Z"
  //     fill="#0442D2"
  //   />
  //   <path
  //     d="m12.004 12.25-1.474 5.456a.152.152 0 0 1-.147.112h-.868a.152.152 0 0 1-.146-.11l-2-7.06a.152.152 0 0 1 .146-.193h.871c.07 0 .13.046.147.113l1.423 5.504 1.478-5.505a.152.152 0 0 1 .146-.112h.849c.069 0 .129.046.147.112l1.468 5.503 1.422-5.502a.152.152 0 0 1 .147-.113h.871a.152.152 0 0 1 .146.193l-2 7.06a.152.152 0 0 1-.145.11h-.869a.152.152 0 0 1-.146-.112l-1.466-5.457Z"
  //     fill="#fff"
  //   />
  // </svg>
  <svg width="1em" height="1em" viewBox="0 0 38 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111, -336)" fill-rule="nonzero">
        <g transform="translate(111, 336)">
          <path
            d="M9.5,24 L38,24 L38,30 C38,31.1045695 37.0548234,32 35.8888889,32 L11.6111111,32 C10.4451766,32 9.5,31.1045695 9.5,30 L9.5,24 Z"
            fill="#1E3E8C"
          ></path>
          <polygon fill="#2C59B7" points="9.5 16 38 16 38 24 9.5 24"></polygon>
          <polygon fill="#437ACD" points="9.5 8 38 8 38 16 9.5 16"></polygon>
          <path
            d="M11.6111111,0 L35.8888889,0 C37.0548234,0 38,0.8954305 38,2 L38,8 L9.5,8 L9.5,2 C9.5,0.8954305 10.4451766,0 11.6111111,0 Z"
            fill="#5DA3E8"
          ></path>
          <path
            d="M2.11111111,7 L16.8888889,7 C18.2962963,7 19,7.66666667 19,9 L19,23 C19,24.3333333 18.2962963,25 16.8888889,25 L2.11111111,25 C0.703703704,25 0,24.3333333 0,23 L0,9 C0,7.66666667 0.703703704,7 2.11111111,7 Z"
            fill="#3364BF"
          ></path>
          <polygon
            fill="#FFFFFF"
            points="2.67530556 11.069 5.43241667 20.9315 7.49075 20.9315 9.43930556 14.29 9.55330556 14.29 11.5224444 20.9315 13.5665278 20.9315 16.3268056 11.069 14.0753056 11.069 12.4682222 18.1165 12.3494722 18.1165 10.4162222 11.069 8.57586111 11.069 6.67902778 18.1165 6.56344444 18.1165 4.94316667 11.069"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
)

export const fileImageSvg = (
  // <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M3 3a2 2 0 0 1 2-2h9.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z"
  //     fill="#FFC60A"
  //   />
  //   <path
  //     opacity="0.8"
  //     d="M15 1.483a.2.2 0 0 1 .341-.142L20.66 6.66a.2.2 0 0 1-.142.341H17a2 2 0 0 1-2-2V1.483Z"
  //     fill="#D99904"
  //   />
  //   <path
  //     d="M8.372 10a1 1 0 0 0-1 1v.182a1 1 0 0 0 1 1h.181a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-.181Zm8.323 2.76a.6.6 0 0 1 1.04.408V18.5a.5.5 0 0 1-.5.5H7.401a.4.4 0 0 1-.307-.657l2.926-3.49a1 1 0 0 1 1.532 0l1.523 1.816 3.62-3.91Z"
  //     fill="#fff"
  //   />
  // </svg>

  // <svg width="1em" height="1em" viewBox="0 0 38 32" xmlns="http://www.w3.org/2000/svg">
  //   <defs>
  //     <path
  //       d="M36.2523749,28.8 L1.67007408,28.8 C0.746473469,28.8 0,27.9374719 0,26.8702528 L0,1.92974719 C0,0.862528109 0.746473469,0 1.67007408,0 L36.2523749,0 C37.1759755,0 37.922449,0.862528109 37.922449,1.92974719 L37.922449,26.8702528 C37.922449,27.9325656 37.1717713,28.8 36.2523749,28.8 Z"
  //       id="path-1"
  //     ></path>
  //   </defs>
  //   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
  //     <g transform="translate(-111, -528)">
  //       <g transform="translate(111, 528)">
  //         <path
  //           d="M28.4630699,10.247191 L0,10.247191 L0,1.68096629 C0,0.751332584 0.747322796,0 1.6719426,0 L24.1438601,0 C24.8827746,0 25.5329343,0.483923596 25.7440346,1.1970427 L28.4630699,10.247191 Z"
  //           fill="#CBD6E5"
  //           fill-rule="nonzero"
  //         ></path>
  //         <g transform="translate(0.0776, 3.2)">
  //           <mask id="mask-2" fill="white">
  //             <use xlinkHref="#path-1"></use>
  //           </mask>
  //           <use fill="#4E8DF6" fill-rule="nonzero" xlinkHref="#path-1"></use>
  //           <path
  //             d="M4.31377551,7.25877551 C4.31377551,8.68783783 5.06822954,10.0083459 6.29294213,10.7228771 C7.51765473,11.4374083 9.02656288,11.4374083 10.2512755,10.7228771 C11.4759881,10.0083459 12.2304421,8.68783783 12.2304421,7.25877551 C12.2304421,5.04963649 10.4582359,3.25877551 8.2721088,3.25877551 C6.08598169,3.25877551 4.31377551,5.04963649 4.31377551,7.25877551 L4.31377551,7.25877551 Z"
  //             fill="#FFFFFF"
  //             fill-rule="nonzero"
  //             mask="url(#mask-2)"
  //           ></path>
  //           <path
  //             d="M32.8040816,9.91346939 C30.477551,7.56244898 26.677551,7.56244898 24.3510204,9.91346939 L5.97142857,28.4865306 L5.66122449,28.8 L37.922449,28.8 L37.844898,15.0857143 L32.8040816,9.91346939 Z"
  //             fill="#2166CC"
  //             fill-rule="nonzero"
  //             mask="url(#mask-2)"
  //           ></path>
  //           <path
  //             d="M25.8244898,28.8 L12.6408163,15.3991837 C10.3142857,13.0481633 6.51428571,13.0481633 4.1877551,15.3991837 L0.0775510204,19.6310204 L-0.0387755102,28.8 L25.8244898,28.8 Z"
  //             fill="#629FF9"
  //             fill-rule="nonzero"
  //             mask="url(#mask-2)"
  //           ></path>
  //         </g>
  //       </g>
  //     </g>
  //   </g>
  // </svg>

  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3a2 2 0 0 1 2-2h9.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z"
      fill="#FFC60A"
    ></path>
    <path
      opacity="0.8"
      d="M15 1.483a.2.2 0 0 1 .341-.142L20.66 6.66a.2.2 0 0 1-.142.341H17a2 2 0 0 1-2-2V1.483Z"
      fill="#D99904"
    ></path>
    <path
      d="M8.372 10a1 1 0 0 0-1 1v.182a1 1 0 0 0 1 1h.181a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-.181Zm8.323 2.76a.6.6 0 0 1 1.04.408V18.5a.5.5 0 0 1-.5.5H7.401a.4.4 0 0 1-.307-.657l2.926-3.49a1 1 0 0 1 1.532 0l1.523 1.816 3.62-3.91Z"
      fill="#fff"
    ></path>
  </svg>
)

export const filePdfSvg = (
  // <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M3 3a2 2 0 0 1 2-2h9.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z"
  //     fill="#F54A45"
  //   />
  //   <path
  //     d="M15 1.483a.2.2 0 0 1 .341-.142L20.66 6.66a.2.2 0 0 1-.142.341H17a2 2 0 0 1-2-2V1.483Z"
  //     fill="#C02A26"
  //   />
  //   <path
  //     d="M17.55 15.551c-.247-.29-.756-.432-1.555-.432-.464 0-1.104.012-1.747.107-1.755-1.265-2.167-2.625-2.167-2.625s.3-.753.319-1.982c.012-.777-.111-1.357-.425-1.606a.883.883 0 0 0-.524-.195.7.7 0 0 0-.413.13c-.913.658.084 3.762.11 3.845a27.6 27.6 0 0 1-1.531 3.125c-.182.316-.182.322-.304.466 0 0-1.597.792-2.347 1.67-.423.497-.437.838-.414 1.093.036.307.427.58.82.58l.048-.001c.4-.024.844-.134 1.339-.602.358-.339.76-1.258 1.278-2.158 1.485-.417 2.792-.713 3.887-.883.803.427 1.998.91 2.811.91.273 0 .493-.056.653-.164.191-.13.272-.29.323-.589.05-.298-.02-.525-.16-.689Zm-1.745.467c.742 0 1.143.131 1.35.241.063.034.11.067.142.094-.058.045-.172.102-.379.102-.342 0-.792-.145-1.34-.433.077-.002.153-.004.227-.004Zm-4.26-6.542.002-.003c.116.085.17.684.16 1.031-.016.466-.019.646-.078.933-.158-.597-.17-1.67-.083-1.961Zm.037 4.36c.362.596.82 1.2 1.338 1.66-1.01.217-1.847.415-2.45.626a18.647 18.647 0 0 0 1.112-2.285ZM7.51 18.885c.092-.134.341-.396.974-.902-.34.782-.721.902-1.075 1.09.026-.061.06-.126.101-.188Z"
  //     fill="#fff"
  //   />
  // </svg>
  <svg width="1em" height="1em" viewBox="0 0 38 32" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g>
        <path
          d="M30 0L10.6117 0C10.1846 -2.02056e-07 9.77485 0.160426 9.47264 0.446029C9.17042 0.731633 9.00043 1.11905 9 1.52316V8H38L30 0Z"
          fill="#FE3343"
        />
        <path
          opacity="0.8"
          d="M30 0L38 8H33.2C32.0799 8 31.5198 8 31.092 7.78201C30.7157 7.59027 30.4097 7.28431 30.218 6.90798C30 6.48016 30 5.92011 30 4.8V0Z"
          fill="white"
        />
        <path d="M38 8H9V16H38V8Z" fill="#EE1A2B" />
        <path d="M38 16H9V24H38V16Z" fill="#DD0012" />
        <path
          d="M38 24H9V30.4771C9.00043 30.8809 9.17021 31.268 9.47209 31.5535C9.77397 31.839 10.1833 31.9996 10.6102 32H36.3882C36.8157 32 37.2256 31.8394 37.5279 31.5535C37.8302 31.2676 38 30.8799 38 30.4756V24Z"
          fill="#CB0011"
        />
        <path
          opacity="0.2"
          d="M17.3328 7.00149H9V26H17.3328C17.7744 25.9992 18.1977 25.8421 18.5101 25.563C18.8225 25.2839 18.9987 24.9056 19 24.5107V8.49078C18.9991 8.09564 18.8232 7.71691 18.5107 7.43751C18.1982 7.1581 17.7747 7.00079 17.3328 7V7.00149Z"
          fill="black"
        />
        <path
          d="M1.5005 7.0015H16.4995C16.8972 7.0015 17.2786 7.15938 17.56 7.44046C17.8413 7.72153 17.9996 8.1028 18 8.5005V23.4995C18 23.8975 17.8419 24.2791 17.5605 24.5605C17.2791 24.8419 16.8975 25 16.4995 25H1.499C1.1013 24.9996 0.72003 24.8413 0.438956 24.56C0.157882 24.2786 -1.89531e-07 23.8972 0 23.4995L0 8.5005C0 8.10254 0.158088 7.72088 0.439486 7.43949C0.720885 7.15809 1.10254 7 1.5005 7V7.0015Z"
          fill="#DD0012"
        />
        <path
          d="M13.7268 19.1895C12.7502 19.1083 11.8147 18.7629 11.0418 18.1124C9.56559 18.4404 8.12253 18.9028 6.73073 19.4937C5.61207 21.4845 4.55415 22.5 3.65978 22.5C3.47661 22.5 3.25232 22.4589 3.11027 22.3581C2.70373 22.1752 2.5 21.7692 2.5 21.3828C2.5 21.058 2.58131 20.1443 6.0186 18.6612C6.80556 17.2328 7.44617 15.7287 7.9307 14.1718C7.50361 13.2992 6.54756 11.1665 7.19801 10.0894C7.4223 9.68342 7.84939 9.48089 8.31667 9.50142C8.68302 9.50142 9.04936 9.68342 9.25216 9.96809C9.71944 10.6177 9.67925 11.999 9.06899 14.03C9.65513 15.111 10.4104 16.0915 11.3063 16.9345C12.0586 16.7926 12.8315 16.6918 13.5838 16.6918C15.2922 16.732 15.537 17.5234 15.4959 17.991C15.5361 19.1895 14.3371 19.1895 13.7268 19.1895ZM3.57754 21.4435L3.68034 21.4033C4.18874 21.2204 4.59527 20.8545 4.87938 20.3879C4.33079 20.6119 3.9037 20.9572 3.57848 21.4435H3.57754ZM8.39798 10.5776H8.29611C8.25593 10.5776 8.19425 10.5776 8.15406 10.6177C8.01201 11.2272 8.11294 11.8777 8.37835 12.4657C8.57777 11.8531 8.58462 11.1942 8.39798 10.5776ZM8.6419 15.8173L8.60171 15.8985L8.56059 15.8584C8.23462 16.6917 7.87515 17.5115 7.48305 18.3159L7.56436 18.2757V18.3569C8.37 18.0665 9.19156 17.8222 10.025 17.6252L9.98485 17.585H10.0858C9.54424 17.0476 9.06032 16.4551 8.6419 15.8173ZM13.5838 17.7474C13.2586 17.7474 12.9745 17.7474 12.6493 17.8286C13.0147 18.0116 13.381 18.0713 13.7268 18.1124C13.9698 18.1535 14.2352 18.1124 14.4586 18.0312C14.4586 17.9304 14.3165 17.7474 13.5838 17.7474Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
)

export const filePptSvg = (
  // <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M3 3a2 2 0 0 1 2-2h9.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z"
  //     fill="#FF811A"
  //   />
  //   <path
  //     opacity="0.5"
  //     d="M15 1.483a.2.2 0 0 1 .341-.142L20.66 6.66a.2.2 0 0 1-.142.341H17a2 2 0 0 1-2-2V1.483Z"
  //     fill="#C25705"
  //   />
  //   <path
  //     d="M10.383 18.495V14.91h1.702c.409 0 .816-.036 1.22-.108a3.484 3.484 0 0 0 1.11-.386 2.3 2.3 0 0 0 .814-.77c.212-.329.316-.742.316-1.236a3.3 3.3 0 0 0-.132-.937 1.95 1.95 0 0 0-.478-.815c-.23-.236-.538-.42-.923-.552-.381-.131-.86-.196-1.435-.196H9.414a.141.141 0 0 0-.142.141v8.445c0 .078.064.142.142.142h.828a.141.141 0 0 0 .14-.142Zm2.735-4.622a6.67 6.67 0 0 1-1.01.069h-1.725v-3.066h1.966c.746 0 1.282.13 1.608.38.318.245.478.605.478 1.094 0 .339-.054.608-.158.809-.104.2-.25.355-.44.47-.194.119-.433.2-.719.244Z"
  //     fill="#fff"
  //   />
  // </svg>
  <svg width="1em" height="1em" viewBox="0 0 38 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111, -400)" fill-rule="nonzero">
        <g transform="translate(111, 400)">
          <path
            d="M38,16 L21.5,16 L21.5,0 C25.8760721,0 30.0729116,1.68570945 33.1672619,4.6862915 C36.2616121,7.68687356 38,11.7565362 38,16 L38,16 Z"
            fill="#F09573"
          ></path>
          <path
            d="M21.5,0 L21.5,16 L5,16 C5,7.163444 12.3873016,0 21.5,0 L21.5,0 Z"
            fill="#DD7451"
          ></path>
          <path
            d="M38,16 C38,24.836556 30.6126984,32 21.5,32 C12.3873016,32 5,24.836556 5,16 L38,16 Z"
            fill="#C45A3B"
          ></path>
          <path
            d="M2,7.27272727 L16,7.27272727 C17.3333333,7.27272727 18,7.91919192 18,9.21212121 L18,22.7878788 C18,24.0808081 17.3333333,24.7272727 16,24.7272727 L2,24.7272727 C0.666666667,24.7272727 0,24.0808081 0,22.7878788 L0,9.21212121 C0,7.91919192 0.666666667,7.27272727 2,7.27272727 Z"
            fill="#B74A2B"
          ></path>
          <path
            d="M6.759,21.0850909 L4.6935,21.0850909 L4.702,11.5156262 L8.895,11.5156262 C9.71283012,11.5137011 10.5055377,11.7895429 11.1355,12.2952727 C11.8696392,12.9200439 12.2738191,13.8327112 12.2355,14.7791515 C12.2734133,15.7214321 11.8818979,16.6321695 11.165,17.2693333 C10.5576296,17.7900066 9.77567859,18.0786607 8.965,18.0814545 L6.7595,18.0814545 L6.7595,21.0875152 L6.759,21.0850909 Z M6.759,13.1078788 L6.759,16.5090909 L8.436,16.5090909 C8.74886378,16.5019973 9.05582274,16.4250113 9.333,16.2841212 C9.8760582,15.9866407 10.1903869,15.4094272 10.1375,14.8067879 C10.1901308,14.2066065 9.87773392,13.631607 9.3375,13.334303 C9.05996633,13.1914843 8.75163709,13.1140802 8.4375,13.1083636 L6.7585,13.1083636 L6.759,13.1078788 Z"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const fileXlsSvg = (
  // <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path
  //     d="M3 3a2 2 0 0 1 2-2h9.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Z"
  //     fill="#35BD4B"
  //   />
  //   <path
  //     opacity="0.9"
  //     d="M15 1.483a.2.2 0 0 1 .341-.142L20.66 6.66a.2.2 0 0 1-.142.341H17a2 2 0 0 1-2-2V1.483Z"
  //     fill="#32A645"
  //   />
  //   <path
  //     d="M8.547 9.91h1.091c.049 0 .094.023.122.063l2.098 3.041 2.11-3.041a.147.147 0 0 1 .121-.064h1.092a.147.147 0 0 1 .12.233l-2.733 3.834 2.95 4.155a.147.147 0 0 1-.12.233h-1.092a.147.147 0 0 1-.121-.064l-2.327-3.363L9.543 18.3a.147.147 0 0 1-.122.064H8.33a.147.147 0 0 1-.12-.232l2.928-4.156-2.71-3.835a.147.147 0 0 1 .12-.232Z"
  //     fill="#fff"
  //   />
  // </svg>
  <svg width="1em" height="1em" viewBox="0 0 38 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111, -464)" fill-rule="nonzero">
        <g transform="translate(111, 464)">
          <polygon fill="#2D5B3A" points="9.5 16 23.75 16 23.75 24 9.5 24"></polygon>
          <path
            d="M23.75,16 L38,16 L38,24 L23.75,24 L23.75,16 Z M9.5,8 L23.75,8 L23.75,16 L9.5,16 L9.5,8 Z"
            fill="#387A47"
          ></path>
          <polygon fill="#4FA16B" points="23.75 8 38 8 38 16 23.75 16"></polygon>
          <path
            d="M9.5,24 L38,24 L38,30 C38,31.1045695 37.0548234,32 35.8888889,32 L11.6111111,32 C10.4451766,32 9.5,31.1045695 9.5,30 L9.5,24 Z"
            fill="#2D5B3A"
          ></path>
          <path
            d="M11.6111111,0 L23.75,0 L23.75,8 L9.5,8 L9.5,2 C9.5,0.8954305 10.4451766,0 11.6111111,0 Z"
            fill="#4FA16B"
          ></path>
          <path
            d="M2.11111111,7 L16.8888889,7 C18.2962963,7 19,7.66666667 19,9 L19,23 C19,24.3333333 18.2962963,25 16.8888889,25 L2.11111111,25 C0.703703704,25 0,24.3333333 0,23 L0,9 C0,7.66666667 0.703703704,7 2.11111111,7 Z"
            fill="#357541"
          ></path>
          <path
            d="M23.75,0 L35.8888889,0 C37.0548234,0 38,0.8954305 38,2 L38,8 L23.75,8 L23.75,0 Z"
            fill="#63C187"
          ></path>
          <polygon
            fill="#FFFFFF"
            points="4.75475 11.063 8.05019444 15.9485 4.73627778 20.937 7.09544444 20.937 9.36488889 17.481 9.43930556 17.481 11.7261667 20.937 14.2067222 20.937 10.8336944 15.9485 14.26425 11.063 11.8195833 11.063 9.6235 14.616 9.52955556 14.616 7.32238889 11.063"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
)

export const fileLinkSvg = (
  <svg width="1em" height="1em" viewBox="0 0 38 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-111, -272)" fill-rule="nonzero">
        <g transform="translate(111, 272)">
          <path
            d="M9.18711545,7.3627119 L9.18711545,4.82711869 C9.18691233,4.69744623 9.28959599,4.59025477 9.42091929,4.58305089 L35.854506,4.58305089 C35.9912279,4.58305089 36.102063,4.69232377 36.102063,4.82711869 L36.102063,22.3050848 C36.102063,22.4309502 36.0513483,22.5516605 35.9610756,22.6406609 C35.870803,22.7296612 35.748367,22.779661 35.6207021,22.779661 L30.5732899,22.779661 L30.5732899,24.6779661 L36.0745566,24.6779661 C37.1379496,24.6779661 38,23.828066 38,22.779661 L38,1.89830513 C38,0.849900186 37.1379496,0 36.0745566,0 L9.18711545,0 C8.1396291,0 7.2841182,0.825141776 7.2616721,1.85762717 L7.2616721,7.3627119 L9.18711545,7.3627119 Z M32.0448788,1.55932208 C32.2321421,1.38811359 32.4771698,1.29148394 32.7325371,1.28813563 C32.9845127,1.28809943 33.2264597,1.38546141 33.4064423,1.55932208 C33.5899113,1.73873156 33.6937684,1.98252495 33.6952588,2.23728818 C33.6808504,2.75549259 33.2581498,3.17223542 32.7325371,3.18644072 C32.2008406,3.18644072 31.7698154,2.76149066 31.7698154,2.23728818 C31.7732116,1.98552016 31.8712227,1.74394603 32.0448788,1.55932208 L32.0448788,1.55932208 Z M28.193992,1.55932208 C28.3812554,1.38811359 28.6262831,1.29148394 28.8816504,1.28813563 C29.133626,1.28809943 29.375573,1.38546141 29.5555556,1.55932208 C29.7390246,1.73873156 29.8428816,1.98252495 29.8443721,2.23728818 C29.8299637,2.75549259 29.4072631,3.17223542 28.8816504,3.18644072 C28.6263207,3.18644072 28.3814487,3.08644101 28.2009034,2.90844038 C28.020358,2.73043975 27.9189287,2.48901909 27.9189287,2.23728818 C27.9223249,1.98552016 28.0203359,1.74394603 28.193992,1.55932208 L28.193992,1.55932208 Z M24.3431053,1.55932208 C24.5303687,1.38811359 24.7753963,1.29148394 25.0307637,1.28813563 C25.2827393,1.28809943 25.5246863,1.38546141 25.7046688,1.55932208 C25.8881379,1.73873156 25.9919949,1.98252495 25.9934853,2.23728818 C25.979077,2.75549259 25.5563764,3.17223542 25.0307637,3.18644072 C24.4990672,3.18644072 24.068042,2.76149066 24.068042,2.23728818 C24.0638667,1.98908537 24.1519171,1.74794803 24.315599,1.55932208 L24.3431053,1.55932208 Z"
            fill="#276DFF"
            opacity="0.6"
          ></path>
          <path
            d="M25.6083967,13.6406777 L5.21245024,13.6406777 C4.79785603,13.6404125 4.40098338,13.8064069 4.11305476,14.1005069 C3.82512613,14.3946068 3.67090829,14.7915147 3.68584872,15.2 L3.68584872,26.7932203 C3.68217958,27.1947378 3.84139625,27.5810546 4.12808822,27.8662522 C4.41478019,28.1514498 4.80517615,28.3118644 5.21245024,28.3118644 L25.6083967,28.3118644 C26.4537352,28.3044228 27.1350319,27.6266775 27.1349982,26.7932203 L27.1349982,15.2 C27.1460866,14.7925713 26.9905978,14.3978483 26.7034972,14.1045941 C26.4163965,13.8113398 26.0217836,13.6441704 25.6083967,13.6406777 L25.6083967,13.6406777 Z"
            fill="#D0E0FF"
          ></path>
          <path
            d="M28.8816504,7.32203378 L1.92544336,7.32203378 C0.883168865,7.32161443 0.0297791869,8.13893706 0,9.16610173 L0,30.1423729 C0.0296091771,31.1717842 0.88091918,31.9931101 1.92544336,32 L28.8816504,32 C29.9450434,32 30.8070937,31.1500999 30.8070937,30.1016949 L30.8070937,9.22033902 C30.8070937,8.17193407 29.9450434,7.32203378 28.8816504,7.32203378 Z M24.8244662,8.88135597 C25.0064405,8.70047285 25.2537192,8.59807962 25.5121245,8.59661021 C26.043821,8.59661021 26.4748462,9.02156027 26.4748462,9.54576275 C26.4748462,10.0699652 26.043821,10.4949153 25.5121245,10.4949153 C24.980428,10.4949153 24.5494028,10.0699652 24.5494028,9.54576275 C24.5493661,9.29733863 24.64812,9.05880177 24.8244662,8.88135597 L24.8244662,8.88135597 Z M20.9873326,8.88135597 C21.294693,8.59336534 21.7585404,8.54135543 22.1236457,8.75394436 C22.488751,8.9665333 22.6664993,9.39212353 22.5590858,9.79653671 C22.4516722,10.2009499 22.0851672,10.4860307 21.6612378,10.4949153 C21.1295413,10.4949153 20.6985077,10.0699652 20.6985077,9.54576275 C20.697428,9.2944413 20.8019891,9.0539043 20.9873326,8.88135597 L20.9873326,8.88135597 Z M17.1364459,8.88135597 C17.4438063,8.59336534 17.9076537,8.54135543 18.272759,8.75394436 C18.6378643,8.9665333 18.8156126,9.39212353 18.708199,9.79653671 C18.6007855,10.2009499 18.2342805,10.4860307 17.8103511,10.4949153 C17.2786546,10.4949153 16.847621,10.0699652 16.847621,9.54576275 C16.8465413,9.2944413 16.9511024,9.0539043 17.1364459,8.88135597 L17.1364459,8.88135597 Z M28.8816504,24.6508475 L28.8816504,29.6271186 C28.8816504,29.8892199 28.6661378,30.1016949 28.4002895,30.1016949 L2.4068042,30.1016949 C2.27913937,30.1016949 2.15670335,30.0516951 2.06643068,29.9626947 C1.97615802,29.8736944 1.92544306,29.7529841 1.92544306,29.6271186 L1.92544306,12.1355933 C1.92544306,12.0059208 2.0279239,11.8987293 2.1592472,11.8915255 L28.6340934,11.8915255 C28.7708153,11.8915255 28.8816504,12.0007983 28.8816504,12.1355933 L28.8816504,24.6508475 L28.8816504,24.6508475 Z"
            fill="#276DFF"
          ></path>
          <path
            d="M15.8986609,18.0067797 L15.8986609,16.3525424 C16.0499457,15.6474577 16.6413319,16.081356 16.6413319,16.081356 L20.7672819,19.5661017 C21.674991,20.1762712 20.8360478,20.6372882 20.8360478,20.6372882 L16.8063699,24.0949153 C15.994933,24.6779661 15.9399204,23.7830509 15.9399204,23.7830509 L15.9399204,22.1694915 C11.8139703,20.9084746 10.1773435,25.9661017 10.1773435,25.9661017 C10.0123055,26.2372881 9.92978646,25.9661017 9.92978646,25.9661017 C8.34817228,18.3864407 15.9399204,18.0067797 15.9399204,18.0067797 L15.8986609,18.0067797 Z"
            fill="#276DFF"
            opacity="0.6"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const fileUnknownSvg = (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <path
        d="M1.5 0h14.086a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V26.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 26.5v-25A1.5 1.5 0 011.5 0z"
        id="icon_file_unknow_nor_svg__a"
      ></path>
      <path
        d="M16.293.293l5.414 5.414A1 1 0 0121.91 6H17.5A1.5 1.5 0 0116 4.5V.09a1 1 0 01.293.203z"
        id="icon_file_unknow_nor_svg__b"
      ></path>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(5 2)">
        <use fill="#9CA3AD" xlinkHref="#icon_file_unknow_nor_svg__a"></use>
        <use fill="#646A73" xlinkHref="#icon_file_unknow_nor_svg__b"></use>
      </g>
      <path d="M7.649 10.703h16.648V27.35H7.65z"></path>
      <path
        d="M16.16 12.216c1.236 0 2.23.356 2.987 1.073.72.681 1.081 1.602 1.081 2.749a3.66 3.66 0 01-.76 2.255c-.209.266-.676.72-1.518 1.482-.42.367-.661.618-.849.937-.25.43-.371.87-.371 1.361v.549a.19.19 0 01-.19.189h-1.154a.19.19 0 01-.189-.19v-.548c0-.58.121-1.12.359-1.594.288-.618.835-1.247 1.72-2.02.56-.56.733-.74.854-.891.38-.488.566-.978.566-1.492 0-.754-.221-1.355-.645-1.796-.444-.445-1.088-.664-1.947-.664-.963 0-1.664.314-2.142.95-.378.474-.59.9-.63 1.713a9.425 9.425 0 00-.006.29.19.19 0 01-.19.188h-1.135a.19.19 0 01-.189-.191c.001-.15.003-.248.005-.296.052-1.177.411-1.923 1.08-2.702.787-.907 1.875-1.352 3.263-1.352zm-.755 12.108h1.136a.19.19 0 01.189.19v1.135a.19.19 0 01-.19.189h-1.135a.19.19 0 01-.189-.19v-1.134a.19.19 0 01.19-.19z"
        fill="#ccc"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
)
